module.exports = __webpack_public_path__ + "static/img/5.5eb6190.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/11/zh/5.png
// module id = 2GUZ
// module chunks = 0